/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import { css } from 'styled-components';
import { UiBreakpoint } from '../../utils/constants';

const mobileStyles = css`
	text-align: center;

	.layout-container {
		background: white;
	}

	[class*='page-card'] {
		padding: 0;
	}

	[class*='restriction-card'] {
		max-width: 224px;
		margin: 12px auto;
	}

	.devices {
		margin: 24px 0;
		max-width: none;
	}

	.entrance {
		flex-direction: column;

		.study-qr {
			box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.2);
			padding: 0 0 28px 0;
			&::after {
				top: auto;
				bottom: -10px;
				right: auto;
				left: 50%;
				transform: translateX(-50%);
				padding: 0 16px;
			}
		}

		.study-link {
			padding: 28px 0 0 0;
			min-height: 170px;
			flex-direction: column;
			margin: 20px 0;

			.gz-tooltip__launcher {
				margin-top: 20px;
				width: 100%;

				.gz-button {
					width: 100%;
				}
			}

			&.desktop-only {
				flex-direction: column;
			}
		}
	}
`;

const StudyRestrictionStyles = css`
	.layout-container {
		max-width: 700px;
	}

	.gz-card__content {
		width: 100%;

		.title {
			margin-bottom: 40px;
		}
	}

	.devices {
		display: flex;
		justify-content: space-around;
		margin: 0 auto;
		margin-bottom: 40px;

		.device {
			display: flex;
			flex: 1;
			justify-content: center;
		}
	}

	.entrance {
		display: flex;
		margin-bottom: 30px;

		.study-qr,
		.study-link {
			flex: 1;
			padding: 0 32px;

			h3,
			p {
				margin: 0;
				word-break: break-word;
			}
			p {
				text-align: center;
			}
		}

		.study-qr {
			position: relative;
			box-shadow: 1px 0 0 0 rgba(0, 0, 0, 0.2);
			text-align: center;

			&::after {
				content: attr(data-or);
				position: absolute;
				top: 50%;
				right: 0;
				transform: translate(50%, -50%);
				background: white;
				padding: 12px 0;
			}
			.gz-qr-code {
				margin: 12px 0;
				transform: scale(0.8);
			}
		}

		.study-link {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			padding-bottom: 10px;

			.text {
				display: flex;
				flex-direction: column;
				flex: 1 0 auto;

				h3,
				p {
					text-align: center;
				}
				p {
					align-items: center;
					display: flex;
					flex: inherit;
					justify-content: center;
					word-break: break-all;
				}
			}

			&.desktop-only {
				flex-direction: row;
				flex: 1/2;

				.text {
					flex: auto;
					padding-right: 32px;
					align-items: flex-start;

					p {
						text-align: left;
					}
				}
			}
		}
	}

	// RTL
	&[dir='rtl'] {
		.device-name {
			text-align: initial;
		}

		.entrance {
			.study-qr {
				box-shadow: -1px 0 0 0 rgba(0, 0, 0, 0.2);
				&::after {
					left: -12px;
					right: auto;
				}
			}
		}
	}

	@media (max-width: ${UiBreakpoint}px) {
		${mobileStyles}
	}
	&.is-mobile {
		${mobileStyles}
	}
`;

export default StudyRestrictionStyles;
